import React from "react";

import { css } from "@emotion/css";

import { useStyles } from "@/hooks/useStyles.ts";
import { Page } from "@/uiKit/atoms/page/Page.tsx";
import { PageContent } from "@/uiKit/atoms/page/PageContent.tsx";
import { PageHeader } from "@/uiKit/atoms/page/PageHeader.tsx";
import { LibreviewGroupedInclusionCard } from "@/uiKit/organisms/PatientSync/LibreviewGroupedInclusion/LibreviewGroupedInclusionCard.tsx";
import { PatientSyncLibreviewGuard } from "@/uiKit/organisms/PatientSync/PatientSyncGuards.tsx";

export const PatientSyncLibreviewSelectPage: React.FC = () => {
  const styles = useStyles(makeStyles);

  return (
    <Page id="PatientSyncPage" className={styles.container}>
      <PageHeader />
      <PageContent className={styles.content}>
        <PatientSyncLibreviewGuard>
          <LibreviewGroupedInclusionCard />
        </PatientSyncLibreviewGuard>
      </PageContent>
    </Page>
  );
};

const makeStyles = () => ({
  container: css({}),
  content: css({}),
});
